// ============================================================
// caseExportFlat.ts — the FLAT case record the case banner's Export (CSV /
// PDF) hands to ExportCaseDialog (pure; audit-limitation-parity.test.ts).
// The autosave's flat columns (flattenCase) + identity + the branded band's
// matter number / fee earner + ★ the LINKED CLIENT RECORD, so the PDF's date
// of birth is THE case DOB — the case copy, else the record (caseDobOf) — the
// same as the banner. Without `client` a blank case DOB printed "no date of
// birth" in the PDF while the banner showed a child estimate.
// ============================================================
import { flattenCase } from '../../hooks/useAutoSave'
import type { Case } from '../../types/case.types'

export const caseExportFlat = (c: Case): Record<string, unknown> => ({
  id: c.id,
  createdAt: c.createdAt,
  ...flattenCase(c),
  // For the branded PDF band (matter number + fee earner).
  matterNumber: c.matterNumber,
  assignedTo: c.assignedTo ?? null,
  client: c.client ?? null,
  // The limitation estimate's capacity note (not a case column).
  protectedParty: c.protectedParty === true,
})
